import React, { useEffect, useState } from "react";
import { api, euroFormat, dateFormat, formatApiErrorDetail, resolveImageUrl } from "../../lib/api";
import BildUpload from "../../components/BildUpload";

export default function ShopAdmin() {
  const [tab, setTab] = useState("produkte");
  return (
    <div className="space-y-5" data-testid="shop-admin-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <h1 className="text-3xl font-heading font-bold text-falke-blue">Shop-Verwaltung</h1>
      </div>
      <div className="inline-flex bg-white rounded-xl p-1 border border-falke-blue/10 shadow-sm">
        <button onClick={() => setTab("produkte")} className={`px-4 py-2 rounded-lg text-sm font-semibold ${tab === "produkte" ? "bg-falke-orange text-white" : "text-falke-blue"}`} data-testid="tab-shop-produkte">Produkte</button>
        <button onClick={() => setTab("bestellungen")} className={`px-4 py-2 rounded-lg text-sm font-semibold ${tab === "bestellungen" ? "bg-falke-orange text-white" : "text-falke-blue"}`} data-testid="tab-shop-bestellungen">Bestellungen</button>
      </div>
      {tab === "produkte" ? <ProdukteTab /> : <BestellungenTab />}
    </div>
  );
}

function blankProdukt() {
  return { name: "", beschreibung: "", bild_url: "", coin_preis: null, geld_preis_brutto: null, bestand: -1, aktiv: true, kategorie: "" };
}

function ProdukteTab() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(blankProdukt());
  const load = () => api.get("/admin/shop/produkte").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const body = { ...form, coin_preis: form.coin_preis === "" ? null : form.coin_preis, geld_preis_brutto: form.geld_preis_brutto === "" ? null : form.geld_preis_brutto };
      if (editing) await api.put(`/admin/shop/produkte/${editing.id}`, body);
      else await api.post("/admin/shop/produkte", body);
      setEditing(null); setForm(blankProdukt()); load();
    } catch (e) { alert(formatApiErrorDetail(e.response?.data?.detail)); }
  };
  const remove = async (id) => { if (!window.confirm("Wirklich löschen?")) return; await api.delete(`/admin/shop/produkte/${id}`); load(); };
  const edit = (p) => { setEditing(p); setForm({ ...p }); };

  return (
    <>
      <div className="falke-card p-6 space-y-3">
        <h3 className="font-heading text-lg text-falke-blue">{editing ? `Bearbeite: ${editing.name}` : "Neues Produkt"}</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="px-3 py-2 rounded-xl border border-falke-blue/15" data-testid="sp-name" />
          <input placeholder="Kategorie" value={form.kategorie} onChange={(e) => setForm({ ...form, kategorie: e.target.value })} className="px-3 py-2 rounded-xl border border-falke-blue/15" />
          <div className="sm:col-span-2">
            <BildUpload
              value={form.bild_url}
              onChange={(p) => setForm({ ...form, bild_url: p })}
              endpoint="/admin/shop/bild-upload"
              label="Produktbild"
              testId="sp-bild-upload"
            />
          </div>
          <textarea placeholder="Beschreibung" value={form.beschreibung} onChange={(e) => setForm({ ...form, beschreibung: e.target.value })} className="sm:col-span-2 px-3 py-2 rounded-xl border border-falke-blue/15" />
          <input type="number" placeholder="Coin-Preis (leer = nicht in FC)" value={form.coin_preis ?? ""} onChange={(e) => setForm({ ...form, coin_preis: e.target.value === "" ? null : Number(e.target.value) })} className="px-3 py-2 rounded-xl border border-falke-blue/15" data-testid="sp-coin" />
          <input type="number" step="0.01" placeholder="Geld-Preis brutto (leer = nicht in Geld)" value={form.geld_preis_brutto ?? ""} onChange={(e) => setForm({ ...form, geld_preis_brutto: e.target.value === "" ? null : Number(e.target.value) })} className="px-3 py-2 rounded-xl border border-falke-blue/15" data-testid="sp-geld" />
          <input type="number" placeholder="Bestand (-1 = unbegrenzt)" value={form.bestand} onChange={(e) => setForm({ ...form, bestand: Number(e.target.value) })} className="px-3 py-2 rounded-xl border border-falke-blue/15" />
          <label className="flex items-center gap-2"><input type="checkbox" checked={form.aktiv} onChange={(e) => setForm({ ...form, aktiv: e.target.checked })} className="w-4 h-4 accent-falke-orange" /> Aktiv im Shop</label>
        </div>
        <div className="flex gap-2">
          <button onClick={save} className="btn-primary" data-testid="sp-save">{editing ? "Aktualisieren" : "Anlegen"}</button>
          {editing && <button onClick={() => { setEditing(null); setForm(blankProdukt()); }} className="btn-outline">Abbrechen</button>}
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 items-start">
        {items.map((p) => (
          <div key={p.id} className="falke-card overflow-hidden" data-testid={`sp-card-${p.id}`}>
            {p.bild_url && <div className="h-32 bg-falke-warmwhite flex items-center justify-center p-3"><img src={resolveImageUrl(p.bild_url)} alt="" className="max-h-full max-w-full object-contain" /></div>}
            <div className="p-4">
              <div className="font-semibold text-falke-blue">{p.name}</div>
              <div className="text-xs text-falke-anthracite/70 line-clamp-2">{p.beschreibung}</div>
              <div className="flex flex-wrap gap-2 mt-2 text-xs">
                {p.coin_preis != null && <span className="text-falke-orange font-bold">{p.coin_preis} FC</span>}
                {p.geld_preis_brutto != null && <span className="text-falke-blue font-bold">{euroFormat(p.geld_preis_brutto)}</span>}
                {!p.aktiv && <span className="text-rose-600">inaktiv</span>}
              </div>
              <div className="flex gap-2 mt-3">
                <button onClick={() => edit(p)} className="btn-outline !py-1.5 text-xs flex-1">Bearbeiten</button>
                <button onClick={() => remove(p.id)} className="text-rose-600 text-xs hover:underline">Löschen</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

function BestellungenTab() {
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState("");
  const load = () => api.get("/admin/shop/bestellungen").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const setStatus = async (bid, status) => {
    if (status === "storniert") {
      const b = items.find((x) => x.id === bid);
      const info = [
        b?.coins_abgezogen > 0 ? `${b.coins_abgezogen} FC werden dem Kunden zurückgebucht` : null,
        b?.paypal_capture_id ? `${(b.geld_betrag_brutto || 0).toFixed(2)} € werden via PayPal erstattet` : null,
      ].filter(Boolean).join("\n");
      if (!window.confirm(`Bestellung wirklich stornieren?\n\n${info || "Keine automatische Erstattung nötig."}`)) { load(); return; }
    }
    try {
      const r = await api.post(`/admin/shop/bestellungen/${bid}/status`, { status });
      if (status === "storniert") {
        const d = r.data;
        setMsg(`Storniert. ${d.coins_refund > 0 ? `${d.coins_refund} FC zurückgebucht.` : ""} ${d.paypal_refund_id ? `PayPal-Refund: ${d.paypal_refund_id}` : ""}`);
      } else setMsg("");
    } catch (e) {
      setMsg(e.response?.data?.detail || "Fehler beim Statuswechsel.");
    }
    load();
  };

  return (
    <div className="space-y-3">
      {msg && <div className="text-sm font-semibold text-falke-blue" data-testid="storno-msg">{msg}</div>}
      <div className="falke-card overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="text-left text-falke-blue/70 text-xs uppercase tracking-wider border-b border-falke-blue/10">
          <tr><th className="px-4 py-3">Datum</th><th>Kunde</th><th>Produkt</th><th>Menge</th><th>Zahlung</th><th>Status</th><th>Aktion</th></tr>
        </thead>
        <tbody>
          {items.map((b) => (
            <tr key={b.id} className="border-t border-falke-blue/5" data-testid={`sb-${b.id}`}>
              <td className="px-4 py-3">{dateFormat(b.erstellt_am)}</td>
              <td>{b.kunde_name}</td>
              <td>{b.produkt_name}</td>
              <td className="tabular">{b.menge}</td>
              <td className="text-xs">{b.bezahlung === "coins" ? `${b.coins_abgezogen} FC` : euroFormat(b.geld_betrag_brutto)}</td>
              <td><span className="status-badge bg-falke-blue/10 text-falke-blue">{b.status}</span></td>
              <td>
                <select onChange={(e) => setStatus(b.id, e.target.value)} value={b.status} className="px-2 py-1 rounded-md border border-falke-blue/15 text-xs" data-testid={`sb-status-${b.id}`}>
                  <option value="neu">neu</option>
                  <option value="bestaetigt">bestaetigt</option>
                  <option value="versendet">versendet</option>
                  <option value="zugestellt">zugestellt</option>
                  <option value="storniert">storniert</option>
                </select>
              </td>
            </tr>
          ))}
          {items.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-falke-anthracite/60">Keine Bestellungen.</td></tr>}
        </tbody>
      </table>
      </div>
    </div>
  );
}
